import type { ReactNode } from "react";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";

/** 独立工作台的浏览器级外壳：持久化主题、完整路由与全局 toast。 */
export function StandaloneSurface({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      {children}
      <Toaster position="top-center" offset={{ top: "72px" }} className="rounded-full" />
    </ThemeProvider>
  );
}
